export enum ToastColorEnum {
    info = 'is-info',
    link = 'is-link',
    dark = 'is-dark',
    danger = 'is-danger',
    warning = 'is-warning',
    success = 'is-success',
}

export type ToastColor = ToastColorEnum.info | ToastColorEnum.link | ToastColorEnum.dark | ToastColorEnum.danger |
    ToastColorEnum.warning | ToastColorEnum.success;
